import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useMediaQuery, useTheme } from '@mui/material';

import { BasicDateRangePicker } from 'components';
import { toQueryString } from 'utils';

interface DashboardDateRangePickerProps {
  start: string;
  end: string;
}

export const DashboardDateRangePicker = ({ start, end }: DashboardDateRangePickerProps) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const up_md = useMediaQuery(theme.breakpoints.up('md'));
  const down_lg = useMediaQuery(theme.breakpoints.down('lg'));

  const direction = up_md && down_lg ? 'vertical' : 'horizontal';

  const onChange = ({ start, end }: { start: string; end: string }) => {
    const qs = toQueryString({ start, end });
    navigate(qs ? `?${qs}` : '');
  };

  return <BasicDateRangePicker start={start} end={end} onChange={onChange} direction={direction} />;
};
